
const digest = '732db19ee7d94b99bdf2a7080a3bd8a2d20e03f530f062b933f461cc7cb4f0ff';
const classes = {"wrapper":"_wrapper_ah90c_1","text":"_text_ah90c_12"};
const css = `._wrapper_ah90c_1 {
  height: 100%;
  width: 100%;
  background-image: url("/dist/placeholder/nodata.svg");
  background-repeat: no-repeat;
  background-position: right bottom;
  padding: 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
}

._text_ah90c_12 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  